import React, { Component } from 'react';

class DotLoader extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div class={`dot-loader ${this.props.size || "medium"} ${this.props.variant || "light"}`}>
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        );
    }
}

export default DotLoader;

